export const BLOCKED_UPLOAD_EXTENSIONS = Object.freeze(['zip']);

export const BLOCKED_UPLOAD_MIME_TYPES = Object.freeze([
  'application/zip',
  'application/x-zip-compressed',
]);

export const FILE_TYPE_NOT_ALLOWED_CODE = 'file-type-not-allowed';
export const ZIP_FILE_NOT_ALLOWED_MESSAGE = 'ZIP files are not allowed';

const getExtension = (value) => {
  if (typeof value !== 'string' || !value) return '';

  const fileName = value.split(/[?#]/)[0].split('/').pop() || '';
  const lastDotIndex = fileName.lastIndexOf('.');

  if (lastDotIndex < 0 || lastDotIndex === fileName.length - 1) return '';

  return fileName.slice(lastDotIndex + 1).toLowerCase();
};

export const getUploadValidationError = (file, uploadPath = '') => {
  const fileExtension = getExtension(file?.name);
  const pathExtension = getExtension(uploadPath);
  const mimeType = typeof file?.type === 'string' ? file.type.toLowerCase() : '';

  const isBlockedExtension =
    BLOCKED_UPLOAD_EXTENSIONS.includes(fileExtension) ||
    BLOCKED_UPLOAD_EXTENSIONS.includes(pathExtension);
  const isBlockedMimeType = BLOCKED_UPLOAD_MIME_TYPES.includes(mimeType);

  if (!isBlockedExtension && !isBlockedMimeType) return null;

  return {
    code: FILE_TYPE_NOT_ALLOWED_CODE,
    message: ZIP_FILE_NOT_ALLOWED_MESSAGE,
  };
};

export const isUploadBlocked = (file, uploadPath = '') =>
  Boolean(getUploadValidationError(file, uploadPath));

export const createUploadValidationError = (validationError) => {
  const error = new Error(validationError.message);
  error.name = 'UploadValidationError';
  error.code = validationError.code;
  error.status = 400;
  return error;
};
